import CmpVerticalOptions from "./CmpVerticalOptions";

export default CmpVerticalOptions;